<template>
  <div style="height: 100%" class="tile-layer">
    <l-map
      style="width: 100%; height: 100%"
      ref="positionMap"
      :zoom="zoom"
      :center="center"
      :max-bounds="maxBounds"
      @update:zoom="zoomUpdated"
      @update:center="centerUpdated"
      @update:bounds="boundsUpdated"
      minZoom="5"
      maxZoom="10"
    >
      <l-tile-layer :url="url"></l-tile-layer>
      <v-marker-cluster :options="clusterOptions" v-if="cities">
        <l-marker
            v-for="city in cities"
            :key="city.city"
            :lat-lng="getLatLng(city)"
            @click="cityClick(city)"
            :icon="icon"
        >
          <l-icon
            :icon-anchor="staticAnchor">
            <div class="job-count-icon">{{city.jobCount}}</div>
          </l-icon>
        </l-marker>
      </v-marker-cluster>
      <!-- <v-marker-cluster :options="clusterOptions" v-if="jobs">
        <l-marker
            v-for="job in jobs"
            :key="job.id"
            :lat-lng="getLatLng(job)"
            :icon="icon"
        ></l-marker>
      </v-marker-cluster> -->
    </l-map>
  </div>
</template>
<script>
import { latLng, latLngBounds, icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LIcon, LTooltip } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
import Cities from "@/assets/fi-cities.json";
import { baseURL } from '../api/api';

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip,
    'v-marker-cluster': Vue2LeafletMarkerCluster
  },
  name: "PositionMap",
  data() {
    return {
      url: baseURL + '/api/maps/basic/{z}/{x}/{y}.png',
      zoom: 5,
      center: [65.101342, 27.212741],
      bounds: null,
      maxBounds: latLngBounds([
        [71.0, 32.0],
        [59.0, 19.0]
      ]),
      markerLatLng: latLng(65.101342, 27.212741),
      icon: icon({
        iconUrl: require("@/assets/map-marker.png"),
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      clusterOptions: {
        spiderfyOnMaxZoom: false,
        showCoverageOnHover: false
      },
      staticAnchor: [25, 50]
    };
  },
  mounted() {
  },
  watch: {
    cities: function (){
      // Get cities layer coords and fit bounds
        this.$refs.positionMap.mapObject.fitBounds(this.cities.map((c) => { return [c.lat, c.lng] }), { maxZoom: 10 });
    }
  },
  methods: {
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    getLatLng(city) {
      if(city.lat !== null ) return latLng(city.lat, city.lng);
    },
    cityClick(city){
      console.log("city clicked", city);

      let terms = {
        keywords: this.$store.state.searchTerms.keywords,
        area: city.city
      }

      let routeParams = {
        keyword: this.$store.state.searchTerms.keywords,
        areas: city.city.toLowerCase()
      }

      // If selected city is already a filter, clear the filter
      
      if(
        this.$store.state.searchTerms.area !== null &&
        this.$store.state.searchTerms.area.toLowerCase() == city.city.toLowerCase()
      ){
        terms.area = "";
        routeParams.areas = "";
      }
      
      this.$store.dispatch("commitSearchTerms", terms);
      this.$store.dispatch("commitSearchResults", terms);

      switch(this.$route.name){
          case 'index':
            this.$router.push({ path: '/', query: routeParams });
            break;
          case 'filter':
          case 'filter2':
              if(routeParams.areas && routeParams.keyword){
                this.$router.push({ name: 'filter2', params: routeParams }, () => {});
              }
              else{
                this.$router.push({ name: 'filter', params: routeParams }, () => {});
              }
            break;
          case 'campaign':
            this.$router.push({ name: 'campaign', query: routeParams });
            break;
             
        }
    }
  },
  computed: {
    cities(){
      //Filter cities list by results and add job count
      let results = this.$store.state.searchResults.filter((job) => job.match);
      let cities = Cities.map((city) => {
        city['jobCount'] =results.filter((job) => {return job.location.city === city.city}).length
        return city;
      }).filter((city) => city.jobCount > 0);
      return cities;
    },
    jobs(){
      //Add city coordinates to search results
      let results = this.$store.state.searchResults;
      results.map((job) => {
          let city = Cities.find((city) => { return city.city === job.location.city });
          if(city){
            job['lat'] = city.lat;
            job['lng'] = city.lon;
          }
          return job;
      });
      return results;
    }
  },
};
</script>
<style>
.leaflet-tile {
  /* Map style adjustment, does not work properly in Safari
  filter: grayscale(100%) sepia(50%) hue-rotate(193deg) contrast(120%)
    saturate(1000%) !important;
  */
  filter: contrast(140%) !important;
}
.leaflet-control.leaflet-bar {
  border: 0 !important;
}
.leaflet-control.leaflet-bar a,
.leaflet-control.leaflet-bar a:first-child,
.leaflet-control.leaflet-bar a:last-child {
  background-color: #002da1;
  color: white;
  border-radius: 6px !important;
  border-top-left-radius: 6px !important;
  border-top-right-radius: 6px !important;
  margin-bottom: 6px;
}
.marker-cluster{
    background-color: #002da1;
    color: white;
    border-radius: 100%;
    display: flex !important;
    align-items: center;
    justify-content: center;
    font-family: "Finlandica", sans-serif;
    font-size: 16px;
    width: 32px !important;
    height: 32px !important;
}
.leaflet-container{
  z-index: 0;
}
.job-count-icon{
  
  color: #fff;
  width: 50px;
  height: 50px;
  display: flex;
  padding-top: 10px;
  justify-content: center;
  border-radius: 100%;
  font-family: "Finlandica", sans-serif;
  font-weight: bold;
  background-image: url('~@/assets/map-marker-solid.svg');
  background-size: cover;
}
</style>
<style scoped>
</style>
